// extracted by mini-css-extract-plugin
export default {"root":"CellCol-root__jjxI"};